import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

import DialogContent from '@material-ui/core/DialogContent';
import ProfileForm from 'components/Forms/ProfileForm.jsx';
import Button from 'components/CustomButtons/Button.jsx';

const Transition = (props) => {
  return <Slide direction='down' {...props} />;
};

export const UpdateProfileModal = ({ user, open, close, classes, handleSubmit }) => (
  <Dialog
    classes={{
      root: classes.modalRoot,
      paper: classes.modal + ' ' + classes.modalSmall,
    }}
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={close}
    aria-labelledby='shipment-modal-slide-title'
    aria-describedby='shipment-modal-slide-description'
  >
    <DialogContent
      id='shipment-modal-slide-description'
      className={classes.modalBody}
    >
      {user.uid ? <ProfileForm user={user} handleSubmit={handleSubmit} modalOpen={open} /> : null}
      <Button
        className={classes.ltrButtonWhite}
        style={{
          marginLeft: '10px',
          marginTop: '10px',
          float: 'right',
          backgroundColor: 'grey',
          borderRadius: '50px',
          margin: '-70px 30px 0px 0px',
        }}
        key='close'
        aria-label='Close'
        onClick={close}
      >
        <b>Close</b>
      </Button>
    </DialogContent>
  </Dialog>
);

UpdateProfileModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(Style)(UpdateProfileModal);
